import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
export var labelStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "2717919018",
    children: [".jsx-2717919018{font-size:0.8125rem;font-style:italic;margin-bottom:1px;display:block;}", ".jsx-2717919018::after{content:':';}"]
  }),
  className: "jsx-2717919018"
};
export var valueStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "144339533",
    children: [".jsx-144339533{font-weight:700;line-height:1.25;}"]
  }),
  className: "jsx-144339533"
};
export var subHeadingStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "1715855886",
    children: [".jsx-1715855886{font-size:0.9375rem;font-weight:700;text-transform:uppercase;-webkit-text-decoration:none;text-decoration:none;color:#21409A;}", "a.jsx-1715855886:hover{-webkit-text-decoration:none;text-decoration:none;font-weight:700;}"]
  }),
  className: "jsx-1715855886"
};